import script from "./EvaluacionExpertosView.vue?vue&type=script&lang=ts&setup=true"
export * from "./EvaluacionExpertosView.vue?vue&type=script&lang=ts&setup=true"

import "./EvaluacionExpertosView.vue?vue&type=style&index=0&id=358849a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-358849a8"]])

export default __exports__